<script>
  export let item;
  export let colourRows = 1;
  export let changeColourFn;

  function changeColour(colour) {
    changeColourFn(colour);
  }
</script>

<div class="colours">
  {#if item?.colours.length > 0 && colourRows > 0}
    {#each { length: colourRows } as _, i}
      {#if item.colours[i]}
        {#if item.colours[i].ProductColoursMasterTrim3}
          <!-- 4-colour gradient (each 25%) -->
          <div
            on:click|stopPropagation={() => changeColour(item.colours[i])}
            on:mouseenter={() => changeColour(item.colours[i])}
            title={item.colours[i].displayName}
            class="colour"
            style="
              background: linear-gradient(
                90deg,
                rgb{item.colours[i].ProductColoursMasterMain.rgb}0%, rgb{item.colours[i].ProductColoursMasterMain
              .rgb}       25%,
                rgb{item.colours[i].ProductColoursMasterTrim1.rgb}25%, rgb{item.colours[i].ProductColoursMasterTrim1
              .rgb}     50%,
                rgb{item.colours[i].ProductColoursMasterTrim2.rgb}50%, rgb{item.colours[i].ProductColoursMasterTrim2
              .rgb}     75%,
                rgb{item.colours[i].ProductColoursMasterTrim3.rgb}75%, rgb{item.colours[i].ProductColoursMasterTrim3
              .rgb}100%
              );
            "
          />
        {:else if item.colours[i].ProductColoursMasterTrim2}
          <!-- 3-colour gradient (each ~33%) -->
          <div
            on:click|stopPropagation={() => changeColour(item.colours[i])}
            on:mouseenter={() => changeColour(item.colours[i])}
            title={item.colours[i].displayName}
            class="colour"
            style="
              background: linear-gradient(
                90deg,
                rgb{item.colours[i].ProductColoursMasterMain.rgb}0%, rgb{item.colours[i].ProductColoursMasterMain
              .rgb}33.33%,
                rgb{item.colours[i].ProductColoursMasterTrim1.rgb}33.33%, rgb{item.colours[i].ProductColoursMasterTrim1
              .rgb}     66.67%,
                rgb{item.colours[i].ProductColoursMasterTrim2.rgb}66.67%, rgb{item.colours[i].ProductColoursMasterTrim2
              .rgb}100%
              );
            "
          />
        {:else if item.colours[i].ProductColoursMasterTrim1}
          <!-- 2-colour gradient (each 50%) -->
          <div
            on:click|stopPropagation={() => changeColour(item.colours[i])}
            on:mouseenter={() => changeColour(item.colours[i])}
            title={item.colours[i].displayName}
            class="colour"
            style="
              background: linear-gradient(
                90deg,
                rgb{item.colours[i].ProductColoursMasterMain.rgb}0%, rgb{item.colours[i].ProductColoursMasterMain
              .rgb}50%,
                rgb{item.colours[i].ProductColoursMasterTrim1.rgb}50%, rgb{item.colours[i].ProductColoursMasterTrim1
              .rgb}100%
              );
            "
          />
        {:else if item.colours[i].ProductColoursMasterMain}
          <!-- Single-colour -->
          <div
            on:click|stopPropagation={() => changeColour(item.colours[i])}
            on:mouseenter={() => changeColour(item.colours[i])}
            title={item.colours[i].displayName}
            class="colour"
            style="background-color: rgb{item.colours[i].ProductColoursMasterMain.rgb};"
          />
        {/if}
      {/if}
    {/each}
  {/if}
</div>

<style>
  .colours {
    display: grid;
    grid-template-columns: repeat(auto-fit, 25px);
    margin-top: 0.5rem;
    justify-content: center;
  }

  .colour {
    width: 2rem;
    height: 2rem;
    border-radius: 10%;
    margin: 0.2rem;
    border: 1px solid;
  }
</style>
